var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-area"},[_c('h2',[_vm._v(_vm._s(_vm.textTitle))]),_c('p'),_vm._l((_vm.textLinesArray),function(line){return _c('p',{key:line,domProps:{"innerHTML":_vm._s(line)}},[_vm._v(" "+_vm._s(line)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }